/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CommmonService } from 'src/app/utils/common.service';
import { Votes, ActiveUser } from '../interfaces/benefit-body.interface';
import { ValuationService } from 'src/app/home/services/valuation.service';
import { BenefitsService } from 'src/app/home/services/benefits.service';
import { TabRequestsModule } from 'src/app/workflow/tab-requests/tab-requests.module';
import { MantenedorService } from 'src/app/home/services/mantenedor.service';

@Component({
  selector: 'app-benefit-body',
  templateUrl: './benefit-body.component.html',
  styleUrls: ['./benefit-body.component.scss'],
})
export class BenefitBodyComponent implements OnInit {
  @Output() newRating = new EventEmitter();

  images: any = [];
  showGallery = false;      // Controla el popup principal
  imageZoom: any = null;         // Controla qué imagen está agrandada

  detail = '';
  rating = 0;
  mouseOver = 0;
  validador = false;
  idBeneficio = 0;
  getActiveUser = JSON.parse(
    this.commonService.getItemLocalStorage('activeUser') ?? '[]',
  );
  postVotestar: ActiveUser = {
    idemployee: '',
    email: '',
    idbenefit: 0,
    quantity: 0,
  };
  messageVote = '¡Gracias por valorar este beneficio!';
  selectedVote = false;
  arrStar = [1, 2, 3, 4, 5];
  average: any;
  totalVotes: any;
  title!: string;
  mantenedor!: any;
  star: Votes[] = [
    { valor: 1, numberVotes: 0 },
    { valor: 2, numberVotes: 0 },
    { valor: 3, numberVotes: 0 },
    { valor: 4, numberVotes: 0 },
    { valor: 5, numberVotes: 0 },
  ];

  constructor(
    private router: ActivatedRoute,
    private commonService: CommmonService,
    private valuetionService: ValuationService,
    private benefitService: BenefitsService,
    private mantenedor_service: MantenedorService,
    private common_service: CommmonService
  ) {}

  async ngOnInit() {
    this.router.queryParams.subscribe(async (params: any) => {
      const benefit = this.getBenefit(params);  

      if (benefit) {
        const valoracion = await this.benefitService.getValuationsBenefit(benefit.id);
        this.detail = benefit.detail;
        this.title = benefit.title;
        this.idBeneficio = benefit.id;
        this.average = benefit.average;
        this.totalVotes = benefit.totalStars;
        
        if(benefit.id === 24) {
          const imagenes_beneficios = await this.common_service.get_datos_manatenedor_categoria(5);
          imagenes_beneficios.forEach((element: any) => {
            this.images.push({
              link: element["informacion"]["link"],
              descripcion: element["informacion"]["descripcion"]
            });
          })
          console.log(imagenes_beneficios, "imagenes_beneficios");
        }
        
        for (const element of this.star) {
          switch (element.valor) {
            case 1:
              element.numberVotes = valoracion.quantityStarOne;
              break;
            case 2:
              element.numberVotes = valoracion.quantityStarTwo;
              break;
            case 3:
              element.numberVotes = valoracion.quantityStarThree;
              break;
            case 4:
              element.numberVotes = valoracion.quantityStarFour;
              break;
            case 5:
              element.numberVotes = valoracion.quantityStarFive;
              break;
          }
        }
      }
    });
    window.scrollTo(0, 0);
  }

  getBenefit(params: any) {
    const benefits = JSON.parse(
      this.commonService.getItemLocalStorage('benefits') ?? '[]',
    );
    return benefits.length === 0
      ? undefined
      : benefits.find((b: any) => b.id === parseInt(params.idBenefit));
  }

  selectStart(select: number) {
    if (select !== this.rating) {
      this.rating = select;
    } else {
      this.rating = this.rating - 1;
    }
    this.voteStar(select);
    this.newRating.emit(this.rating);
  }

  notselecStar() {
    this.validador = false;
    this.mouseOver = 0;
  }

  selectStarMouse(select: any) {
    this.validador = true;
    if (select !== this.rating) {
      this.mouseOver = select;
    } else {
      this.mouseOver = this.mouseOver - 1;
    }
  }

  async voteStar(select: any) {
    this.postVotestar.email = this.getActiveUser.info.email;
    this.postVotestar.idbenefit = this.idBeneficio;
    this.postVotestar.quantity = select;

    if (this.getActiveUser.info.userData != null) {
      this.postVotestar.idemployee =
        this.getActiveUser.info.userData.idEmpleado;
    } else {
      this.postVotestar.idemployee = '';
    }

    const payload = {
      "beneficio_id": this.idBeneficio,
      "valor": select
    }

    await this.postValorationBenefit(payload);
  }

  async postValorationBenefit(payload: any) {
    try {
      const postValuation =
        await this.valuetionService.postValuations(payload);
      if (postValuation.statusCode === 200) {
        this.selectedVote = true;
      }
    } catch (error) {
      console.error('Error al guardar valoración:', error);
    }
  }

  percentage(element: number, numberStar: number) {
    if (this.selectedVote) {
      const newVotantes = this.totalVotes + 1;
      if (numberStar === this.rating) {
        element = element + 1;
      }
      const resultado2 = (element * 100) / newVotantes;
      return resultado2;
    } else {
      const resultado = (element * 100) / this.totalVotes;
      return resultado;
    }
  }

  averageOficial() {
    if (this.selectedVote) {
      for (const element of this.star) {
        if (this.rating == element.valor) {
          const setSuma = this.average * this.totalVotes + this.rating;
          const newtotalvotantes = this.totalVotes + 1;
          return (setSuma / newtotalvotantes);
        }
      }
    } else {
      return this.average;
    }
  }

  toggleGallery() {
    this.showGallery = !this.showGallery;
    this.imageZoom = null; // Resetear zoom al cerrar
  }

  zoomImage(img: any) {
    this.imageZoom = img;
  }

  closeZoom() {
    this.imageZoom = null;
  }
}
